import {createFileRoute} from '@tanstack/react-router';
import {WindowsPage} from '@/features/agent';

export const Route = createFileRoute('/_app/agents/windows')({
  component: () => <WindowsPage />,
});
